export default __webpack_public_path__ + "static/media/tailwind.68603ef4.svg";